(function () {

    function preventScrollDown() {
        const target = document.querySelector('.customer-register__form');
        // prevents the page from scrolling down when the content changes
        if (target) {
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        window.scrollTo({top: 0, behavior: 'smooth'});
                        // document.querySelector('.theme').remove();

                    }
                }
            });

            observer.observe(target, {
                childList: true,
                subtree: true,
            });
        }
    }

    function addLabelClass(container) {
        const floatsLabel = container.querySelectorAll('.customer-register .customer-register__form .cf-field');

        floatsLabel.forEach((element) => {
            const label = element.querySelector('label');
            const input = element.querySelector('input, textarea');
            if (label && input) {
                input.addEventListener('keyup', (event) => {
                    if (event.target.value !== '') {
                        label.classList.add('label--float');
                    } else {
                        label.classList.remove('label--float');
                    }
                });
                if (input.value && input.value.length) {
                    label.classList.add('label--float');
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        CF.ready(() => {
            const sbmitButton = document.querySelector('.customer-register .cf-form-actions button[type="submit"]');
            const termsPrivacyCheckbox = document.querySelector('.customer-register .customer-register__terms-and-privacy input[type="checkbox"]');
            const termsPrivacyText = document.querySelector('.customer-register .customer-register__terms-and-privacy span');

            addLabelClass(document)

            sbmitButton.classList.add('btn', 'btn--primary', 'btn--solid', 'btn--large');
            sbmitButton.setAttribute('disabled', true);

            termsPrivacyText.innerHTML = 'By creating an account, you agree to our <a href="/pages/privacy-policy">Terms of Use</a>. and <a href="/pages/privacy-policy">Privacy Policy</a> *';

            termsPrivacyCheckbox.addEventListener('change', (event) => {
                if (event.currentTarget.checked) {
                    sbmitButton.removeAttribute('disabled');
                } else {
                    sbmitButton.setAttribute('disabled', true);
                }
            })
        })
    });

    document.addEventListener('shopify:section:load', (e) => {
        CF.ready(() => {
            addLabelClass(document);
        })
    });

    preventScrollDown();
})();